import React from 'react';

const ForaturaELavaggioReportsTable = ({ children, action = undefined }) => {

  return (
    <div className='table-responsive'>
      <table className='table table-hover align-middle'>
        <thead>
        <tr>
          <th className='text-end'>Controllo</th>
          <th className='text-center'>Diametro</th>
          <th className='text-center'>Posizione</th>
          <th className='text-center'>Visivo</th>
        </tr>
        <tr>
          <th className='text-end'>Tolleranza</th>
          <th className='text-center'>+0,5mm/-0,5mm</th>
          <th className='text-center'>+1mm/-1mm</th>
          <th className='text-center'></th>
        </tr>
        </thead>
        <tbody>
        {children}
        </tbody>
        {action}
      </table>
    </div>
  )

}

export default ForaturaELavaggioReportsTable
